// Action enums
export enum ActionTypes {
  SET_TOKEN = "SET_TOKEN",
  SET_PROFILE = "SET_PROFILE",
  SET_SPLASH_SCREEN = "SET_SPLASH_SCREEN",
  LOGOUT = "LOGOUT",
}
